<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="authors-note">
<p style="text-align: center; font-family: Times New Roman; padding-top:60px; padding-bottom:10px; font-size:30px; letter-spacing:1px; font-weight:normal;">AUTHOR’S NOTE</p>
<p style="text-align: center;"> <img alt="line" src="media/line.png"/></p>
<p><br/><br/><br/>When I told my late mother and father that I was writing a novel, they asked me straight away if it was autobiographical. There are a few events and situations that friends and family might indeed recognise as being so; we draw on our experience, as well as our imagination, for inspiration.</p>
<p>This book raises a potpourri of issues. Events take place in recognisable public locations in South London, each serving a specific purpose in the story. I love London and it is a delight to set the narrative in such a wonderful city.</p>
<p>I need to stress that the incident in St Paul’s Cathedral is fictional. The words and actions by the priests are my words and do not reflect the current views of the Church of England, but perhaps in the fullness of time, they may indeed be embraced by this great institution. At the end of the day, we are the mysterious creation of a mysterious God.</p>
<p>All references to events in the story linked to the Palace of Westminster and Members of Parliament are also fictional.</p>
<p>Needless to say, none of the old-age homes mentioned in the story exist, with the exception of Trinity Hospice in Clapham, which is a superb haven for those in need of care.</p>
<p>Finally, I want to say that this book is about raw honesty and total transparency in a complex and dysfunctional world. I am using this book to give voice to all the questions that I wanted to ask but never did, and at the same time, to offer the ‘right’ answers, however squirmy they might be for those giving them. Life can make you squirm and perhaps even shudder at aspects of it in intimate detail, but these aspects contribute to the rich and variegated tapestry of being a human being, and what we call life.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?1c4c7b45